var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Possession = /** @class */ (function (_super) {
    __extends(Possession, _super);
    function Possession() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Possession.prototype.render = function () {
        var clsMdf = this.props.modifier ? " rj-scoreboard__possession--" + this.props.modifier : "";
        var clsSevice = this.props.onService ? " rj-scoreboard__possession--service" : "";
        return (React.createElement("span", { className: "rj-scoreboard__possession" + clsMdf + clsSevice }, " "));
    };
    return Possession;
}(React.PureComponent));
export { Possession };
//# sourceMappingURL=Possession.js.map